'use client'

import GridFinderLogo from '@/components/icons/logos/grid-finder-new'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { useState } from 'react'
import { verifyBetaAccess } from './action'

export default function BetaLoginPage() {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(event) {
    event.preventDefault()
    setLoading(true)
    setError('')

    const formData = new FormData(event.currentTarget)
    const result = await verifyBetaAccess(formData)

    if (result.success) {
      // Hard refresh/redirect to ensuring middleware passes now
      window.location.href = '/'
    } else {
      setError(result.message)
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-neutral-950 p-4">
      <div className="mb-8 scale-150">
        <GridFinderLogo className="h-12 fill-white" />
      </div>

      <Card className="w-full max-w-sm border-neutral-800 bg-neutral-900 text-white">
        <CardHeader>
          <CardTitle className="text-center text-xl font-bold">
            Beta Access
          </CardTitle>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                htmlFor="username"
              >
                Username
              </label>
              <Input
                id="username"
                name="username"
                required
                className="border-neutral-700 bg-neutral-950 text-white placeholder:text-neutral-500 focus-visible:ring-neutral-700"
              />
            </div>
            <div className="space-y-2">
              <label
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                htmlFor="password"
              >
                Password
              </label>
              <Input
                id="password"
                name="password"
                type="password"
                required
                className="border-neutral-700 bg-neutral-950 text-white placeholder:text-neutral-500 focus-visible:ring-neutral-700"
              />
            </div>
            {error && (
              <p className="text-center text-sm font-medium text-red-500">
                {error}
              </p>
            )}
          </CardContent>
          <CardFooter>
            <Button
              type="submit"
              className="w-full bg-white text-black hover:bg-neutral-200 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Verifying...' : 'Enter'}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  )
}
